import React from 'react';
import { useLocation } from 'react-router-dom';
import Button, { ButtonSizes, ButtonTypes } from '../../components/views/button';
import './mobile-unsupported.scss';
import Image from '../../components/views/image/image';
import LaptopImage from '../../../assets/images/laptop.png';
import { getFromSessionStorage, setInSessionStorage } from '../../utils/session-storage-utils';
import useTranslation from '../../utils/translation-utils';
import { MOBILE_UNSUPPORTED_ROUTES_EXCLUSION_LIST } from '../../constants/session-storage-keys';

const MobileUnsupported = () => {
  const { pathname } = useLocation();
  const [getTranslation] = useTranslation();
  const onClickHandler = () => {
    const exclusionList = getFromSessionStorage(MOBILE_UNSUPPORTED_ROUTES_EXCLUSION_LIST) || [];
    exclusionList.push(pathname);
    setInSessionStorage(MOBILE_UNSUPPORTED_ROUTES_EXCLUSION_LIST, exclusionList);
    window.location.reload();
  };

  return (
    <div className="mobile-unsupported-page">
      <Image src={LaptopImage} alt="laptop" className="mobile-unsp-laptop" />
      <div className="mobile-unsp-header">
        {getTranslation('MOBILE_UNSUPPORTED_SCREEN_HEADER')}
      </div>
      <div className="mobile-unsp-sub-header">
        {getTranslation('MOBILE_UNSUPPORTED_SCREEN_DESCRIPTION')}
      </div>
      <Button
        type={ButtonTypes.PRIMARY}
        size={ButtonSizes.MEDIUM}
        label="I_WANT_TO_CONTINUE"
        className="mobile-unsp-button"
        onClick={onClickHandler}
      />
    </div>
  );
};

export default MobileUnsupported;
